import { useRef } from "react";
import { usePUR5020_R01Store } from "src/containers/mes/PUR/PUR5020_R01/Store_PUR5020_R01";
import { Content_PUR5020_R01 } from "./Content_PUR5020_R01";
import { SearchSection_PUR5020_R01 } from "./SearchSection_PUR5020_R01";
import { Table_PUR5020_R01 } from "./Table_PUR5020_R01";
import { DetailTable_PUR5020_R01 } from "./DetailTable_PUR5020_R01";
import { Message } from "src/components/common/form/Message";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import useUiuxStore from "src/store/useUiuxStore";
import { useMouseContent } from "src/utils/mouse/mouseContent";
import { AgGridReact } from "ag-grid-react";
import { PUR5020_R01HeaderDto, PUR5020_R01DetailDto } from "./Dto_PUR5020_R01";

export const Container_PUR5020_R01 = () => {
	const { initData } = usePUR5020_R01Store();
	const { setMessage } = useUiuxStore();

	const RESIZER = {
		code: 'PUR5020_R01',
		type: 'width',
		storageKey: 'PUR5020_R01-split-width',
		min: 10,
		max: 90,
		default: 50,
	} as const;

	const gridRef = useRef<AgGridReact<PUR5020_R01HeaderDto>>(null);
	const detailGridRef = useRef<AgGridReact<PUR5020_R01DetailDto>>(null);
	const containerRef = useRef<HTMLDivElement>(null);
	const detailRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	const { splitValue, handleMouseDown } = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef: detailRef,
	});

	const {
		fetchData,
		initContainerData,
		handleDetailExcelClick,
		handleTableRowClick,
	} = Content_PUR5020_R01({
		gridRef,
		detailGridRef,
		setMessage,
	});

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={() => {}}
				onDeleteClick={() => {}}
				onSaveClick={() => {}}
				onExcelClick={handleDetailExcelClick}
				onInitClick={initContainerData}
			/>
			<SearchSection_PUR5020_R01 />
			<div className="flex-1 flex gap-[4px] p-[12px]" ref={containerRef}>
				<div className="h-full" style={{ width: `${splitValue}%` }}>
					<Table_PUR5020_R01 onRowClick={handleTableRowClick} gridRef={gridRef} />
				</div>
				<div
					className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
					onMouseDown={(e) => handleMouseDown('LR', e.nativeEvent)}
				/>
				<div className="h-full" style={{ width: `${100 - splitValue}%` }} ref={detailRef}>
					<DetailTable_PUR5020_R01 gridRef={detailGridRef} />
				</div>
			</div>
			<Message />
		</div>
	);
};

export default Container_PUR5020_R01;
